module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "level-form"
    }
  }, [_vm._l((_vm.kelasList), function(kelas) {
    return _c('v-card', {
      key: kelas,
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-actions', [_c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("Kelas")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "value": kelas,
        "outlined": "",
        "disabled": "",
        "filled": ""
      }
    })], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.expanded[kelas] = !_vm.expanded[kelas]
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(_vm.expanded[kelas] ? "mdi-chevron-up" : "mdi-chevron-down"))])], 1)], 1), _vm._v(" "), _c('v-expand-transition', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.expanded[kelas]),
        expression: "expanded[kelas]"
      }],
      staticClass: "mx-5"
    }, [_vm._l((_vm.levelTemplate), function(lvl, idx) {
      return _c('div', {
        key: idx
      }, [_c('v-divider', {
        staticClass: "my-4"
      }), _vm._v(" "), _c('v-list-item', {
        staticClass: "pa-0",
        attrs: {
          "two-line": ""
        }
      }, [_c('v-list-item-content', {
        staticClass: "pa-0"
      }, [_c('v-list-item-title', {
        staticClass: "font-weight-bold pb-2"
      }, [_vm._v("Level")]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "value": lvl.value,
          "outlined": "",
          "disabled": "",
          "filled": ""
        }
      })], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', [_c('v-list-item', {
        staticClass: "pa-0",
        attrs: {
          "two-line": ""
        }
      }, [_c('v-list-item-content', {
        staticClass: "pa-0"
      }, [_c('v-list-item-title', {
        staticClass: "font-weight-bold pb-2"
      }, [_vm._v("Minimal\n                                            Poin")]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "outlined": ""
        },
        model: {
          value: (lvl.min_poin),
          callback: function($$v) {
            _vm.$set(lvl, "min_poin", $$v)
          },
          expression: "lvl.min_poin"
        }
      })], 1)], 1)], 1), _vm._v(" "), _c('v-col', [_c('v-list-item', {
        staticClass: "pa-0",
        attrs: {
          "two-line": ""
        }
      }, [_c('v-list-item-content', {
        staticClass: "pa-0"
      }, [_c('v-list-item-title', {
        staticClass: "font-weight-bold pb-2"
      }, [_vm._v("Maksimal\n                                            Poin")]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "outlined": ""
        },
        model: {
          value: (lvl.max_poin),
          callback: function($$v) {
            _vm.$set(lvl, "max_poin", $$v)
          },
          expression: "lvl.max_poin"
        }
      })], 1)], 1)], 1)], 1)], 1)], 1)
    }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.submit(kelas)
        }
      }
    }, [_vm._v("\n                        Simpan Level Kelas " + _vm._s(kelas) + "\n                    ")])], 1)], 2)])], 1)
  }), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-5"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('uncompleted')
      }
    }
  }, [_vm._v("Kembali")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "color": "blue",
      "type": "button",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('completed')
      }
    }
  }, [_vm._v("\n            Selesai\n        ")])], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37a63566","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_meter/components/LevelForm.vue
// module id = 959
// module chunks = 1